/**
 * Overwrites the default Shopify loading of the chat widget
 * and loads it with hideChatIcon instead
 */
// Pre-define the initialization options globally
window.KustomerOptions = window.KustomerOptions || {};
window.KustomerOptions.hideChatIcon = true;

// Polyfill the native script behavior to strictly force the option
Object.defineProperty(window, 'Kustomer', {
  configurable: true,
  enumerable: true,
  get: function() {
    return this._KustomerInstance;
  },
  set: function(val) {
    this._KustomerInstance = val;
    if (this._KustomerInstance && typeof this._KustomerInstance.start === 'function') {
      // Intercept Shopify's launch and force the hidden parameter
      var originalStart = this._KustomerInstance.start;
      this._KustomerInstance.start = function(options) {
        options = options || {};
        options.hideChatIcon = true;
        return originalStart.call(this, options);
      };
    }
  }
});

/**
 * Opens the Kustomer chat widget.
 * @param {Event} event
 */
export function openChat(event) {
  if (!window.Kustomer) return;

  event.preventDefault();
  window.Kustomer.open();
}

const targets = document.querySelectorAll('[data-kustomer-chat], a[href="#chat"]')
if (targets.length > 0) {
  targets.forEach((target) => target.addEventListener('click', openChat))
}
